const ExpenseTaxStatusConstants = {
    CALCULATED: 0,
    TAXFREE: 1,
    CUSTOM: 2
}

export default ExpenseTaxStatusConstants